import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { KeyEventUtil } from 'utils'

const FechaVencimientoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('codigoRucSelect', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='FEC VCTO' htmlFor='inputDate-fechaVencimiento' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='fechaVencimiento'>
          {({ field }) => (
            <Form.InputText
              {...field}
              id='inputDate-fechaVencimiento'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaVencimientoFormGroup)
